module.exports = __webpack_public_path__ + "static/media/Iris Street, San Francisco, CA8.cca631dd.jpg";